export const SMART_DOCUMENTS_PERMISSION_CODES = {
  DOCUMENT_MANAGEMENT: 'SMART_DOCUMENTS.GESTION_DE_DOCUMENTOS',
  DOCUMENT_MANAGEMENT_SECTION: 'SMART_DOCUMENTS.VER_SECCION_116',
  CREATE_SUBMISSION: 'SMART_DOCUMENTS.CREAR_ENVIO',
  DOWNLOAD_MANAGEMENT_EXCEL: 'SMART_DOCUMENTS.DESCARGAR_EXCEL_118',
  VIEW_DOCUMENT: 'SMART_DOCUMENTS.VER_DOCUMENTO',
  MANAGE_AND_ADD_COMMENT: 'SMART_DOCUMENTS.GESTIONAR_Y_AGREGAR_COMENTARIO',
  CANCEL_REQUEST: 'SMART_DOCUMENTS.CANCELAR_SOLICITUD',
  DOCUMENT_REGISTRY: 'SMART_DOCUMENTS.REGISTRO_DE_DOCUMENTOS',
  DOCUMENT_REGISTRY_SECTION: 'SMART_DOCUMENTS.VER_SECCION_123',
  DOWNLOAD_REGISTRY_EXCEL: 'SMART_DOCUMENTS.DESCARGAR_EXCEL_124',
  VIEW_DETAIL: 'SMART_DOCUMENTS.VER_DETALLE',
  DOWNLOAD_DOCUMENT: 'SMART_DOCUMENTS.DESCARGAR_DOCUMENTO',
  MARK_AS_LOADED: 'SMART_DOCUMENTS.MARCAR_COMO_CARGADO',
};
